import styled from 'styled-components'
import { TextWrapper } from '../../styles/base'

export const Container = styled(TextWrapper)`
  width: 100%;
  margin-bottom: 70px;
  margin-top: 80px;
`

export const ImageContainer = styled.li`
  position: absolute;
  width: 100px;
  height: 100px;
  overflow: hidden;
  transform: translate(-50%, -50%) rotate(-45deg);
  border-radius: 3px;
`

export const ImageGroup = styled.ul`
  position: relative;
  right: 130px;
  top: 130px; 
  list-style: none;
  margin: 0;
  padding: 0;

  ${ImageContainer}:nth-child(1) {
    top: -80px;

    img {
      /* Each image needs slight translate() to make the face centered */
      transform: rotate(45deg) translate(-8px, -9px);
    }
  }

  ${ImageContainer}:nth-child(2) {
    left: 80px;
    top: 5px;

    img {
      transform: rotate(45deg) translate(-55px, -10px);
    }
  }

  ${ImageContainer}:nth-child(3) {
    top: 80px;
    left: -10px;

    img {
      transform: rotate(45deg) translate(-26px, -10px);
    }
  }
`

export const CrewImage = styled.img`
  width: 225px;
  margin: -20px 0 0 -65px;
`
